export default "__VITE_ASSET__DaVDJfma__"